export * from './referent.model';
export * from './referent.service';
export * from './referent-detail.component';
export * from './referent.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/referent/index.ts